import { render, staticRenderFns } from "./EditCategoryFields.vue?vue&type=template&id=34eb11c2&"
import script from "./EditCategoryFields.vue?vue&type=script&lang=js&"
export * from "./EditCategoryFields.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryFields.vue?vue&type=style&index=0&id=34eb11c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports